// Мини-задания правил B1, уроки 72–86 (тикет 06 .scratch/grammar-unify).
// Слова и примеры — из уроков правил и ниже по линии B1 (.scratch/b1-rework/spec.md).
import type { MiniSet } from './types'

export const MINI_B1_3: MiniSet[] = [
  // b1-l072 — o kadar … ki; öyle … ki
  {
    rule: 'degree-o-kadar-ki',
    explain: 'o kadar - "так, настолько", а ki - союз "что": он открывает вторую половину - что из этого вышло. С öyle - "такой, так": öyle bir gün ki. Союз ki - отдельное слово, стоит после всей первой половины и всегда звучит как ki.',
    examples: [
      {
        parts: [
          { text: 'Masadaki çay ', label: '', why: '' },
          { text: 'o kadar', label: '"так, настолько"', why: 'o kadar ставится прямо перед тем, что усиливаем' },
          { text: ' sıcak ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'отдельное слово, после всей первой половины' },
          { text: ' içemiyorum.', label: '', why: '' },
        ],
        ru: 'Чай на столе такой горячий, что я не могу его пить.',
      },
      {
        parts: [
          { text: 'Annem ', label: '', why: '' },
          { text: 'öyle', label: '"так, такой"', why: 'в разговоре почти то же, что o kadar' },
          { text: ' gurur duydu ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'дальше - полное предложение со своим временем' },
          { text: ' ağladı.', label: '', why: '' },
        ],
        ru: 'Мама так гордилась, что расплакалась.',
      },
    ],
    items: [
      {
        kind: 'transform',
        source: 'O kadar yorgunum, hemen uyuyacağım.',
        sourceRu: 'я так устал, что сейчас же усну',
        instruction: 'Добавьте союз "что" (ki) на его место',
        answer: 'O kadar yorgunum ki hemen uyuyacağım.',
        variants: [],
        breakdown: [
          { text: 'yorgunum ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'ki стоит после всей первой половины, перед результатом' },
        ],
        d: 1,
      },
      {
        kind: 'transform',
        source: 'O kadar güldük, ağladık.',
        sourceRu: 'мы так смеялись, что расплакались',
        instruction: 'Добавьте союз "что" (ki) на его место',
        answer: 'O kadar güldük ki ağladık.',
        variants: ['O kadar çok güldük ki ağladık.'],
        breakdown: [
          { text: 'güldük ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'ki - после сказуемого первой половины' },
        ],
        d: 1,
      },
      {
        kind: 'transform',
        source: 'Çay o kadar sıcak, içemiyorum.',
        sourceRu: 'чай такой горячий, что пить невозможно',
        instruction: 'Добавьте союз "что" (ki) на его место',
        answer: 'Çay o kadar sıcak ki içemiyorum.',
        variants: [],
        breakdown: [
          { text: 'sıcak ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'союз ki - отдельное слово, через пробел (не как в masadaki)' },
        ],
        d: 1,
      },
      {
        kind: 'transform',
        source: 'O kadar ki kızgındım, bağırdım.',
        sourceRu: 'я был так зол, что закричал',
        instruction: 'Исправьте ошибку: ki стоит не на своём месте',
        answer: 'O kadar kızgındım ki bağırdım.',
        variants: ['Öyle kızgındım ki bağırdım.'],
        breakdown: [
          { text: 'O kadar kızgındım ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'ki идёт после всей первой половины, а не сразу после o kadar' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Я так разозлилась, что накричала на него.',
        instruction: 'Переведите: "так..., что..." - o kadar ... ki',
        answer: 'O kadar kızdım ki ona bağırdım.',
        variants: ['Öyle kızdım ki ona bağırdım.'],
        breakdown: [
          { text: 'kızdım ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'не çünkü: çünkü - "потому что", это другой смысл' },
        ],
        blankWhole: true,
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Film çok güzeldi. İki kez izledim.',
        sourceRu: 'фильм был такой хороший, что я посмотрел его два раза',
        instruction: 'Соедините в одну фразу: "такой..., что..." (o kadar ... ki)',
        answer: 'Film o kadar güzeldi ki iki kez izledim.',
        variants: ['Film öyle güzeldi ki iki kez izledim.'],
        breakdown: [
          { text: 'o kadar', label: '"так, настолько"', why: 'вместо çok - прямо перед тем, что усиливаем' },
          { text: ' güzeldi ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'после сказуемого, дальше - результат' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Çok heyecanlıydım. İlk cümleyi unuttum.',
        sourceRu: 'я так волновался, что забыл первую фразу',
        instruction: 'Соедините в одну фразу: "так..., что..." (o kadar ... ki)',
        answer: 'O kadar heyecanlıydım ki ilk cümleyi unuttum.',
        variants: ['Öyle heyecanlıydım ki ilk cümleyi unuttum.'],
        breakdown: [
          { text: 'O kadar', label: '"так, настолько"', why: 'вместо çok' },
          { text: ' heyecanlıydım ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'после всей первой половины' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Çok güzel bir gün. Evde kalamam.',
        sourceRu: 'такой чудесный день, что дома мне не усидеть',
        instruction: 'Соедините через öyle ... ki: "такой..., что..."',
        answer: 'Öyle güzel bir gün ki evde kalamam.',
        variants: ['Öyle güzel bir gün ki evde kalamıyorum.'],
        breakdown: [
          { text: 'Öyle', label: '"такой"', why: 'öyle чаще говорит о качестве, особенно с существительным' },
          { text: ' güzel bir gün ', label: '', why: '' },
          { text: 'ki', label: 'союз "что"', why: 'после первой половины' },
        ],
        d: 3,
      },
    ],
  },

  // b1-l073 — -mış gibi / -iyormuş gibi yapmak
  {
    rule: 'as-if-mis-gibi',
    explain: '"Делать вид" - ...-mış gibi yapmak, дословно "делать как будто". Что "как будто происходит сейчас" - -iyormuş gibi (dinliyormuş gibi), что "как будто уже случилось" - -mış gibi (duymamış gibi), с именем - -ymış gibi (hastaymış gibi). Лицо обычно стоит в конце, на yapmak или davranmak.',
    examples: [
      {
        parts: [
          { text: 'Beni dinl', label: '', why: '' },
          { text: 'iyor', label: 'настоящее -yor', why: 'как будто делает сейчас' },
          { text: 'muş', label: '-mış', why: '"как будто" - картинка, за которую никто не ручается' },
          { text: ' gibi', label: '"как будто"', why: '' },
          { text: ' yapıyor.', label: '', why: '' },
        ],
        ru: 'Он делает вид, что слушает меня.',
      },
      {
        parts: [
          { text: 'Duy', label: '', why: '' },
          { text: 'ma', label: 'отрицание', why: 'как будто не сделал' },
          { text: 'mış', label: '-mış', why: 'как будто уже случилось' },
          { text: ' gibi', label: '"как будто"', why: '' },
          { text: ' yaptı.', label: '', why: '' },
        ],
        ru: 'Он сделал вид, что не услышал.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'uyu',
        baseRu: 'спать',
        task: 'как будто сейчас · -mış',
        context: { tr: '___ gibi yaptım.', ru: 'Я сделал вид, что сплю.' },
        slots: [
          { answer: 'uyu', options: [], label: '', why: '' },
          { answer: 'yor', options: ['yor', 'du'], label: 'как будто сейчас', why: '"как будто делает сейчас" - -iyormuş gibi' },
          { answer: 'muş', options: ['muş', 'du', 'sa'], label: '-mış', why: 'притворство почти всегда с -mış; после "u" - -muş' },
        ],
        answer: 'uyuyormuş',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'duy',
        baseRu: 'слышать',
        task: 'как будто не сделал · -mış',
        context: { tr: '___ gibi yaptı.', ru: 'Он сделал вид, что не услышал.' },
        slots: [
          { answer: 'duy', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'me', 'mı'], label: 'отрицание', why: 'после "u" - -ma' },
          { answer: 'mış', options: ['mış', 'dı', 'sa'], label: 'как будто уже случилось', why: 'не -dı: перед gibi yapmak нужна форма на -mış' },
        ],
        answer: 'duymamış',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'hasta',
        baseRu: 'больной',
        task: 'как будто такой · -ymış',
        context: { tr: '___ gibi yaptı.', ru: 'Он притворился больным.' },
        slots: [
          { answer: 'hasta', options: [], label: '', why: '' },
          { answer: 'ymış', options: ['ymış', 'mış', 'ydı'], label: '-ymış (с именем)', why: 'с именем - -ymış; после гласной вставляется y' },
        ],
        answer: 'hastaymış',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ol',
        baseRu: 'быть, случаться',
        task: 'как будто не случилось · -mış',
        context: { tr: 'Hiçbir şey ___ gibi davrandı.', ru: 'Она вела себя так, будто ничего не случилось.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'me'], label: 'отрицание', why: 'после "o" - -ma' },
          { answer: 'mış', options: ['mış', 'muş', 'dı'], label: 'как будто уже случилось', why: 'после "a" - -mış' },
        ],
        answer: 'olmamış',
        d: 1,
      },
      {
        kind: 'transform',
        source: 'Dinliyor gibi yapıyor.',
        sourceRu: 'делает вид, что слушает (а на самом деле нет)',
        instruction: 'Исправьте: это притворство - перед gibi yapmak нужно -mış',
        answer: 'Dinliyormuş gibi yapıyor.',
        variants: [],
        breakdown: [
          { text: 'Dinl', label: '', why: '' },
          { text: 'iyor', label: 'как будто сейчас', why: '' },
          { text: 'muş', label: '-mış', why: 'без -mış gibi описывает то, что похоже на правду: Dinliyor gibi görünüyor - "вроде слушает"' },
        ],
        d: 2,
      },
      {
        kind: 'affix',
        base: 'tanı',
        baseRu: 'знать (человека)',
        task: 'не · как будто сейчас · -mış',
        context: { tr: 'Sanki beni ___ gibi baktı.', ru: 'Он посмотрел так, будто не знает меня.' },
        slots: [
          { answer: 'tanı', options: [], label: '', why: '' },
          { answer: 'mı', options: ['mı', 'ma', 'mi'], label: 'отрицание', why: 'перед -yor отрицание -mı: tanımıyor' },
          { answer: 'yor', options: ['yor', 'dı'], label: 'как будто сейчас', why: '"будто не знает" - сейчас, -iyormuş' },
          { answer: 'muş', options: ['muş', 'du', 'mış'], label: '-mış', why: 'sanki только усиливает, главную работу делает -mış gibi; после -yor - -muş' },
        ],
        answer: 'tanımıyormuş',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'oku',
        baseRu: 'читать',
        task: 'как будто не сделал · -mış',
        context: { tr: 'Mesajımı ___ gibi yaptı.', ru: 'Он сделал вид, что не читал моё сообщение.' },
        slots: [
          { answer: 'oku', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'me', 'mu'], label: 'отрицание', why: 'после "u" - -ma' },
          { answer: 'mış', options: ['mış', 'muş', 'dı'], label: 'как будто уже случилось', why: 'после "a" - -mış, не -muş' },
        ],
        answer: 'okumamış',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Beni dinlemiyor.',
        sourceRu: 'она меня не слушает',
        instruction: 'Скажите: "Она только делает вид, что слушает меня" (-iyormuş gibi yapmak)',
        answer: 'Beni dinliyormuş gibi yapıyor.',
        variants: ['O beni dinliyormuş gibi yapıyor.'],
        breakdown: [
          { text: 'dinl', label: '', why: '' },
          { text: 'iyor', label: 'как будто сейчас', why: '' },
          { text: 'muş', label: '-mış', why: 'притворство - с -mış' },
          { text: ' gibi yapıyor', label: '"делает вид"', why: 'лицо - в конце, на yapmak' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Мы сделали вид, что понимаем.',
        instruction: 'Переведите: "делать вид" - -iyormuş gibi yapmak',
        answer: 'Anlıyormuş gibi yaptık.',
        variants: [],
        breakdown: [
          { text: 'Anl', label: '', why: '' },
          { text: 'ıyor', label: 'как будто сейчас', why: '' },
          { text: 'muş', label: '-mış', why: 'лицо внутри обычно не повторяют' },
          { text: ' gibi yaptık', label: '"сделали вид"', why: 'лицо "мы" - на yapmak' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Hiçbir şey olmadı.',
        sourceRu: 'ничего не случилось',
        instruction: 'Скажите: "Он ведёт себя так, будто ничего не случилось" (davranmak)',
        answer: 'Hiçbir şey olmamış gibi davranıyor.',
        variants: ['Bir şey olmamış gibi davranıyor.'],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'ma', label: 'отрицание', why: '' },
          { text: 'mış', label: 'как будто уже случилось', why: '' },
          { text: ' gibi davranıyor', label: '"ведёт себя так, будто"', why: 'лицо - в конце, на davranmak' },
        ],
        d: 3,
      },
    ],
  },

  // b1-l074 — -dığı kadar: elimden geldiği kadar
  {
    rule: 'degree-digi-kadar',
    explain: '"Насколько, сколько, в той мере, в какой" - -dığı kadar: форма "то, что" (-dık с лицом) плюс kadar. Лицо сидит на -dık, а kadar не меняется: istediğim kadar, istediğin kadar. Чаще всего встречается elimden geldiği kadar, "насколько в моих силах".',
    examples: [
      {
        parts: [
          { text: 'İste', label: '', why: '' },
          { text: 'diğ', label: '-dık', why: 'форма "то, что"; перед гласной k становится ğ' },
          { text: 'in', label: 'твой (sen)', why: 'лицо сидит на -dık' },
          { text: ' kadar', label: '"сколько"', why: 'kadar не меняется' },
          { text: ' kal.', label: '', why: '' },
        ],
        ru: 'Оставайся сколько хочешь.',
      },
      {
        parts: [
          { text: 'Elimden gel', label: '', why: '' },
          { text: 'diğ', label: '-dık', why: '' },
          { text: 'i', label: 'его', why: '"кто" - сама помощь, она "приходит из моей руки"; "моё" - в elimden' },
          { text: ' kadar', label: '"насколько"', why: '' },
          { text: ' yardım ederim.', label: '', why: '' },
        ],
        ru: 'Помогу чем смогу.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'iste',
        baseRu: 'хотеть',
        task: '"сколько" (-dık) · ты',
        context: { tr: '___ kadar kal.', ru: 'Оставайся сколько хочешь.' },
        slots: [
          { answer: 'iste', options: [], label: '', why: '' },
          { answer: 'diğ', options: ['diğ', 'dik', 'yen'], label: '-dık', why: 'форма "то, что"; перед гласной k смягчается в ğ' },
          { answer: 'in', options: ['in', 'im', 'i'], label: 'твой (sen)', why: '"ты хочешь" - -in' },
        ],
        answer: 'istediğin',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'bil',
        baseRu: 'знать',
        task: '"насколько" (-dık) · я',
        context: { tr: '___ kadarıyla o iyi bir insan.', ru: 'Насколько я знаю, она хороший человек.' },
        slots: [
          { answer: 'bil', options: [], label: '', why: '' },
          { answer: 'diğ', options: ['diğ', 'dik', 'en'], label: '-dık', why: 'форма "то, что"; перед гласной k становится ğ' },
          { answer: 'im', options: ['im', 'in', 'i'], label: 'мой (ben)', why: '"я знаю" - -im' },
        ],
        answer: 'bildiğim',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'iste',
        baseRu: 'хотеть',
        task: '"сколько" (-dık) · мы',
        context: { tr: '___ kadar dinlendik.', ru: 'Мы отдохнули сколько хотели.' },
        slots: [
          { answer: 'iste', options: [], label: '', why: '' },
          { answer: 'diğ', options: ['diğ', 'dik', 'yen'], label: '-dık', why: 'форма "то, что"' },
          { answer: 'imiz', options: ['imiz', 'im', 'iniz'], label: 'наш (biz)', why: '"мы хотели" - -imiz, а kadar не меняется' },
        ],
        answer: 'istediğimiz',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'gel',
        baseRu: 'приходить',
        task: '"насколько" (-dık) · его',
        context: { tr: 'Elimden ___ kadar yardım ederim.', ru: 'Помогу чем смогу.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'diğ', options: ['diğ', 'eceğ', 'en'], label: '-dık', why: 'мера "по силам" - -dığı kadar; -ecek kadar - мера для результата (урок 67)' },
          { answer: 'i', options: ['i', 'im', 'in'], label: 'его', why: 'не "моё": "моё" уже в elimden, а на geldiği - "его" (приходит сама помощь)' },
        ],
        answer: 'geldiği',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'yet',
        baseRu: 'хватать',
        task: '"насколько" (-dık) · его',
        context: { tr: 'Gücüm ___ kadar çalışırım.', ru: 'Буду работать, насколько хватит сил.' },
        slots: [
          { answer: 'yet', options: [], label: '', why: '' },
          { answer: 'tiğ', options: ['tiğ', 'diğ', 'eceğ'], label: '-dık', why: 'после глухой "t" - "t": yettiği' },
          { answer: 'i', options: ['i', 'im'], label: 'его', why: 'хватает "моей силы": "моё" уже в gücüm, на yettiği - "его"' },
        ],
        answer: 'yettiği',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Спрашивайте сколько хотите.',
        instruction: 'Переведите: не вопрос ne kadar, а -dığı kadar',
        answer: 'İstediğiniz kadar sorun.',
        variants: [],
        breakdown: [
          { text: 'İste', label: '', why: '' },
          { text: 'diğ', label: '-dık', why: '' },
          { text: 'iniz', label: 'ваш (siz)', why: '"вы хотите" - лицо на -dık' },
          { text: ' kadar', label: '"сколько"', why: 'ne kadar istiyorsunuz - это вопрос "сколько вы хотите?"' },
        ],
        blankWhole: true,
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Помогу чем смогу.',
        instruction: 'Переведите: "насколько в моих силах" - elimden geldiği kadar',
        answer: 'Elimden geldiği kadar yardım ederim.',
        variants: ['Elimden geldiği kadar sana yardım ederim.', 'Elimden geldiği kadar yardım edeceğim.'],
        breakdown: [
          { text: 'Elimden ', label: '"из моей руки"', why: '"моё" сидит здесь' },
          { text: 'gel', label: '', why: '' },
          { text: 'diğ', label: '-dık', why: '' },
          { text: 'i', label: 'его', why: 'приходит сама помощь' },
          { text: ' kadar', label: '"насколько"', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Насколько я знаю, он хороший человек.',
        instruction: 'Переведите: "насколько я знаю" - bildiğim kadarıyla',
        answer: 'Bildiğim kadarıyla o iyi bir insan.',
        variants: ['Bildiğim kadarıyla iyi bir insan.', 'Bildiğim kadar o iyi bir insan.'],
        breakdown: [
          { text: 'Bil', label: '', why: '' },
          { text: 'diğ', label: '-dık', why: '' },
          { text: 'im', label: 'мой (ben)', why: '' },
          { text: ' kadarıyla', label: '"насколько"', why: 'устойчивое: обычно с -ıyla на конце' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Kolay değil. Sen kolay sanıyorsun.',
        sourceRu: 'это нелегко, а ты думаешь, что легко',
        instruction: 'Скажите одной фразой: "Это не так легко, как ты думаешь" (-dığı kadar + değil)',
        answer: 'Sandığın kadar kolay değil.',
        variants: ['Bu sandığın kadar kolay değil.'],
        breakdown: [
          { text: 'San', label: '', why: '' },
          { text: 'dığ', label: '-dık', why: 'после "a" - -dığ' },
          { text: 'ın', label: 'твой (sen)', why: '' },
          { text: ' kadar', label: '"настолько, как"', why: 'с отрицанием -dığı kadar сравнивает с ожиданием' },
        ],
        d: 3,
      },
    ],
  },

  // b1-l075 — -e -e: okuya okuya, güle güle
  {
    rule: 'converb-e-e-repetition',
    explain: 'Основа глагола + -a / -e, и так два раза: okuya okuya - "читая и читая", то есть долго, много, раз за разом. После гласной вставляется y: oku - okuya, bekle - bekleye. Одиночная форма почти не живёт - её всегда повторяют дважды; лица у неё нет, кто делает - говорит главный глагол в конце.',
    examples: [
      {
        parts: [
          { text: 'Türkçeyi oku', label: '', why: '' },
          { text: 'ya', label: '-a', why: 'основа на гласную - вставляется y' },
          { text: ' oku', label: '', why: '' },
          { text: 'ya', label: 'повтор', why: 'форму всегда говорят дважды: действие длится, повторяется' },
          { text: ' öğrendim.', label: '', why: '' },
        ],
        ru: 'Я выучил турецкий, читая раз за разом.',
      },
      {
        parts: [
          { text: 'Gül', label: '', why: '' },
          { text: 'e', label: '-e', why: 'последняя гласная "ü" - -e' },
          { text: ' gül', label: '', why: '' },
          { text: 'e', label: 'повтор', why: 'gül-e gül-e - "уходи смеясь"' },
          { text: '!', label: '', why: '' },
        ],
        ru: 'Счастливо! (иди с улыбкой)',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'oku',
        baseRu: 'читать',
        task: '"раз за разом" (-a -a)',
        context: { tr: 'Türkçeyi okuya ___ öğrendim.', ru: 'Я выучил турецкий, читая раз за разом.' },
        slots: [
          { answer: 'oku', options: [], label: '', why: '' },
          { answer: 'ya', options: ['ya', 'a', 'ye'], label: '-a', why: 'основа на гласную "u" - -ya' },
        ],
        answer: 'okuya',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'koş',
        baseRu: 'бежать',
        task: '"раз за разом" (-a -a)',
        context: { tr: 'Çocuk ___ koşa geldi.', ru: 'Ребёнок прибежал бегом.' },
        slots: [
          { answer: 'koş', options: [], label: '', why: '' },
          { answer: 'a', options: ['a', 'e', 'ya'], label: '-a', why: 'последняя гласная "o" - -a; после согласной y не нужен' },
        ],
        answer: 'koşa',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'bekle',
        baseRu: 'ждать',
        task: '"раз за разом" (-e -e)',
        context: { tr: 'Seni bekleye ___ yoruldum.', ru: 'Я ждал тебя, ждал - и устал.' },
        slots: [
          { answer: 'bekle', options: [], label: '', why: '' },
          { answer: 'ye', options: ['ye', 'e', 'ya'], label: '-e', why: 'основа на гласную "e" - -ye' },
        ],
        answer: 'bekleye',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'düşün',
        baseRu: 'думать',
        task: '"раз за разом" (-e -e)',
        context: { tr: 'Düşüne ___ bir hikâye yaz.', ru: 'Хорошенько подумав, напиши рассказ.' },
        slots: [
          { answer: 'düşün', options: [], label: '', why: '' },
          { answer: 'e', options: ['e', 'a', 'ye'], label: '-e', why: 'последняя гласная "ü" - -e' },
        ],
        answer: 'düşüne',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ağla',
        baseRu: 'плакать',
        task: '"раз за разом" (-a -a)',
        context: { tr: 'Mektubu ağlaya ___ okudu.', ru: 'Она читала письмо сквозь слёзы.' },
        slots: [
          { answer: 'ağla', options: [], label: '', why: '' },
          { answer: 'ya', options: ['ya', 'yayım', 'a'], label: '-a', why: 'повторяем ту же форму: ağlaya ağlaya; -yayım - это "давай-ка я", другое' },
        ],
        answer: 'ağlaya',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Okuya Türkçe öğrendim.',
        sourceRu: 'я выучил турецкий, много читая',
        instruction: 'Исправьте: так не говорят',
        answer: 'Okuya okuya Türkçe öğrendim.',
        variants: ['Türkçeyi okuya okuya öğrendim.'],
        breakdown: [
          { text: 'Okuya ', label: '', why: '' },
          { text: 'okuya', label: 'повтор', why: 'одиночная форма почти не живёт - её повторяют дважды' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Пользуйся с радостью! (о новой вещи)',
        instruction: 'Переведите пожелание: güle güle + глагол',
        answer: 'Güle güle kullan!',
        variants: [],
        breakdown: [
          { text: 'Gül', label: '', why: '' },
          { text: 'e', label: '-e', why: '' },
          { text: ' gül', label: '', why: '' },
          { text: 'e', label: 'повтор', why: 'той же формой желают радости от новой вещи' },
        ],
        blankWhole: true,
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Türkçeyi çok okudum ve öğrendim.',
        sourceRu: 'я много читал и выучил турецкий',
        instruction: 'Скажите через повтор -a -a: "выучил, читая раз за разом"',
        answer: 'Türkçeyi okuya okuya öğrendim.',
        variants: ['Okuya okuya Türkçe öğrendim.'],
        breakdown: [
          { text: 'oku', label: '', why: '' },
          { text: 'ya', label: '-a', why: 'после гласной - y' },
          { text: ' oku', label: '', why: '' },
          { text: 'ya', label: 'повтор', why: '' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Çok yazarsan yazar olursun.',
        sourceRu: 'если будешь много писать, станешь писателем',
        instruction: 'Скажите через повтор -a -a: "будешь писать и писать - станешь писателем"',
        answer: 'Yaza yaza yazar olursun.',
        variants: [],
        breakdown: [
          { text: 'Yaz', label: '', why: '' },
          { text: 'a', label: '-a', why: 'последняя гласная "a" - -a' },
          { text: ' yaz', label: '', why: '' },
          { text: 'a', label: 'повтор', why: 'путь к результату' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Çocuk koşarak geldi.',
        sourceRu: 'ребёнок прибежал',
        instruction: 'Скажите через повтор -a -a: "прибежал бегом"',
        answer: 'Çocuk koşa koşa geldi.',
        variants: ['Çocuk eve koşa koşa geldi.'],
        breakdown: [
          { text: 'koş', label: '', why: '' },
          { text: 'a', label: '-a', why: '' },
          { text: ' koş', label: '', why: '' },
          { text: 'a', label: 'повтор', why: '-erek - один способ, -a -a - повтор и картина' },
        ],
        d: 3,
      },
    ],
  },

  // b1-l077 — усилительный повтор: bembeyaz, masmavi
  {
    rule: 'intensive-reduplication',
    explain: 'Турок удваивает начало слова: берём начало до первой гласной включительно (be-), добавляем одну согласную - m, p, s или r - и приставляем всё слово: be + m + beyaz = bembeyaz. Пишется слитно, çok не нужен. Надёжного правила для согласной нет - такие слова учат готовыми.',
    examples: [
      {
        parts: [
          { text: 'be', label: '', why: '' },
          { text: 'm', label: 'вставная согласная', why: 'm - запоминается словом, как simsiyah, yemyeşil' },
          { text: 'beyaz', label: 'всё слово', why: 'приставляем слово целиком, слитно' },
        ],
        ru: 'белоснежный',
      },
      {
        parts: [
          { text: 'Deniz bugün ma', label: '', why: '' },
          { text: 's', label: 'вставная согласная', why: 's - реже: masmavi, mosmor' },
          { text: 'mavi', label: 'всё слово', why: '' },
          { text: '.', label: '', why: '' },
        ],
        ru: 'Море сегодня ярко-синее.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'beyaz',
        baseRu: 'белый',
        task: 'усиление: "совсем, очень-очень"',
        context: { tr: 'Duvarlar ___.', ru: 'Стены белоснежные.' },
        slots: [
          { answer: 'be', options: [], label: '', why: '' },
          { answer: 'm', options: ['m', 'p', 's'], label: 'вставная согласная', why: 'bembeyaz - m, запоминается словом' },
          { answer: 'beyaz', options: ['beyaz', 'yaz'], label: 'всё слово', why: 'после согласной приставляем всё слово целиком' },
        ],
        answer: 'bembeyaz',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'mavi',
        baseRu: 'синий',
        task: 'усиление: "совсем, очень-очень"',
        context: { tr: 'Deniz bugün ___.', ru: 'Море сегодня ярко-синее.' },
        slots: [
          { answer: 'ma', options: [], label: '', why: '' },
          { answer: 's', options: ['s', 'm', 'p'], label: 'вставная согласная', why: 'masmavi - s, запоминается словом' },
          { answer: 'mavi', options: ['mavi', 'vi'], label: 'всё слово', why: 'после согласной приставляем всё слово целиком' },
        ],
        answer: 'masmavi',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yeni',
        baseRu: 'новый',
        task: 'усиление: "совсем, очень-очень"',
        context: { tr: 'Bu çanta ___.', ru: 'Эта сумка совершенно новая.' },
        slots: [
          { answer: 'ye', options: [], label: '', why: '' },
          { answer: 'p', options: ['p', 'm', 'r'], label: 'вставная согласная', why: 'yepyeni - p, самая частая согласная' },
          { answer: 'yeni', options: ['yeni', 'ni'], label: 'всё слово', why: 'после согласной приставляем всё слово целиком' },
        ],
        answer: 'yepyeni',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'temiz',
        baseRu: 'чистый',
        task: 'усиление: "совсем, очень-очень"',
        context: { tr: 'Ceket cumartesiye kadar ___ olur.', ru: 'К субботе пиджак будет идеально чистым.' },
        slots: [
          { answer: 'te', options: [], label: '', why: '' },
          { answer: 'r', options: ['r', 'p', 'm'], label: 'вставная согласная', why: 'tertemiz - r, редкая согласная' },
          { answer: 'temiz', options: ['temiz', 'miz'], label: 'всё слово', why: 'после согласной приставляем всё слово целиком' },
        ],
        answer: 'tertemiz',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kırmızı',
        baseRu: 'красный',
        task: 'усиление: "совсем, очень-очень"',
        context: { tr: 'Şu ___ elbiseli kadın kim?', ru: 'Кто эта женщина в ярко-красном платье?' },
        slots: [
          { answer: 'kı', options: [], label: '', why: '' },
          { answer: 'p', options: ['p', 'm', 's'], label: 'вставная согласная', why: 'kıpkırmızı - p, самая частая согласная' },
          { answer: 'kırmızı', options: ['kırmızı', 'rmızı'], label: 'всё слово', why: 'после согласной приставляем всё слово целиком' },
        ],
        answer: 'kıpkırmızı',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'uzun',
        baseRu: 'длинный',
        task: 'усиление: "совсем, очень-очень"',
        context: { tr: 'Saçları ___.', ru: 'Волосы у неё длиннющие.' },
        slots: [
          { answer: 'u', options: [], label: '', why: 'слово начинается с гласной - берётся только она' },
          { answer: 'p', options: ['p', 'm', 's'], label: 'вставная согласная', why: 'upuzun - p' },
          { answer: 'uzun', options: ['uzun', 'zun'], label: 'всё слово', why: 'после согласной приставляем всё слово целиком' },
        ],
        answer: 'upuzun',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'dolu',
        baseRu: 'полный',
        task: 'усиление: "совсем, очень-очень"',
        context: { tr: 'Hafta sonu müze ___ olur.', ru: 'В выходные в музее битком.' },
        slots: [
          { answer: 'do', options: [], label: '', why: '' },
          { answer: 'p', options: ['p', 'm', 's'], label: 'вставная согласная', why: 'dopdolu - p, самая частая согласная' },
          { answer: 'dolu', options: ['dolu', 'lu'], label: 'всё слово', why: 'после согласной приставляем всё слово целиком' },
        ],
        answer: 'dopdolu',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Salon çok yepyeni.',
        sourceRu: 'зал совершенно новый',
        instruction: 'Исправьте: одно слово здесь лишнее',
        answer: 'Salon yepyeni.',
        variants: [],
        breakdown: [
          { text: 'ye', label: '', why: '' },
          { text: 'p', label: 'вставная согласная', why: '' },
          { text: 'yeni', label: 'всё слово', why: 'усиление уже внутри слова - çok не нужен' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Sabah müze çok boştu.',
        sourceRu: 'утром музей был совсем пустым',
        instruction: 'Усильте прилагательное одним словом, без çok',
        answer: 'Sabah müze bomboştu.',
        variants: ['Müze sabah bomboştu.'],
        breakdown: [
          { text: 'bo', label: '', why: '' },
          { text: 'm', label: 'вставная согласная', why: 'bomboş - m' },
          { text: 'boştu', label: 'всё слово', why: 'слитно, çok уже не нужен' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Evler çok temiz.',
        sourceRu: 'дома идеально чистые',
        instruction: 'Усильте прилагательное одним словом, без çok',
        answer: 'Evler tertemiz.',
        variants: [],
        breakdown: [
          { text: 'te', label: '', why: '' },
          { text: 'r', label: 'вставная согласная', why: 'tertemiz - r' },
          { text: 'temiz', label: 'всё слово', why: 'слитно, çok уже не нужен' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Её платье ярко-красное.',
        instruction: 'Переведите одним усиленным словом',
        answer: 'Elbisesi kıpkırmızı.',
        variants: [],
        breakdown: [
          { text: 'kı', label: '', why: '' },
          { text: 'p', label: 'вставная согласная', why: 'kıpkırmızı - p' },
          { text: 'kırmızı', label: 'всё слово', why: 'пишется слитно, не через дефис' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // b1-l078 — ister … ister «хоть … хоть»
  {
    rule: 'correlative-ister',
    explain: 'ister ... ister ставят перед двумя вариантами: выбирай любой, итог один и тот же. ister стоит перед каждым вариантом, повторять его обязательно. Глагол в вариантах - в повелительном, лицо - по собеседнику: ister gel ister gelme; ister gelin ister gelmeyin; ister gelsin ister gelmesin.',
    examples: [
      {
        parts: [
          { text: 'İster', label: 'ister', why: 'перед первым вариантом' },
          { text: ' kabul et ', label: '', why: '' },
          { text: 'ister', label: 'ister', why: 'перед вторым - повторять обязательно' },
          { text: ' etme.', label: '', why: '' },
        ],
        ru: 'Хочешь - соглашайся, хочешь - нет.',
      },
      {
        parts: [
          { text: 'İster', label: 'ister', why: 'варианты бывают и словами' },
          { text: ' çay ', label: '', why: '' },
          { text: 'ister', label: 'ister', why: '' },
          { text: ' kahve, fark etmez.', label: '', why: 'после пары - то, что от выбора не зависит' },
        ],
        ru: 'Хоть чай, хоть кофе - всё равно.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'et',
        baseRu: 'делать (kabul etmek - соглашаться)',
        task: 'повелительное · ты · не',
        context: { tr: 'İster kabul et ister ___.', ru: 'Хочешь - соглашайся, хочешь - нет.' },
        slots: [
          { answer: 'et', options: [], label: '', why: '' },
          { answer: 'me', options: ['me', 'mez', 'medi'], label: 'отрицание (sen)', why: 'повелительное "ты" с отрицанием - etme' },
        ],
        answer: 'etme',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'inan',
        baseRu: 'верить',
        task: 'повелительное · вы · не',
        context: { tr: 'İster inanın ister ___.', ru: 'Хотите верьте, хотите нет.' },
        slots: [
          { answer: 'inan', options: [], label: '', why: '' },
          { answer: 'mayın', options: ['mayın', 'ma', 'mazsınız'], label: 'отрицание (siz)', why: 'на "вы" - -mayın, как в первом варианте inanın' },
        ],
        answer: 'inanmayın',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'gel',
        baseRu: 'приходить',
        task: 'он · не · повелительное (-sın)',
        context: { tr: 'İster gelsin ister ___.', ru: 'Пусть приходит или нет - мне всё равно.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'me', options: ['me', 'ma', 'mez'], label: 'отрицание', why: 'после "e" - -me' },
          { answer: 'sin', options: ['sin', 'sın', 'sün'], label: '-sın (он)', why: 'о третьем лице - -sın; после "e" - -sin' },
        ],
        answer: 'gelmesin',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'beğen',
        baseRu: 'нравиться',
        task: 'повелительное · ты · не',
        context: { tr: 'İster beğen ister ___, bu benim hayatım.', ru: 'Нравится тебе или нет, это моя жизнь.' },
        slots: [
          { answer: 'beğen', options: [], label: '', why: '' },
          { answer: 'me', options: ['me', 'ma', 'mez'], label: 'отрицание (sen)', why: 'после "e" - -me; повелительное: beğenme' },
        ],
        answer: 'beğenme',
        d: 1,
      },
      {
        kind: 'transform',
        source: 'İster kabul et, etme.',
        sourceRu: 'хочешь - соглашайся, хочешь - нет',
        instruction: 'Исправьте: фраза звучит оборванно',
        answer: 'İster kabul et ister etme.',
        variants: ['İster kabul et, ister etme.'],
        breakdown: [
          { text: 'ister', label: 'ister', why: 'ister стоит перед каждым из двух вариантов' },
          { text: ' etme', label: '', why: '' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Приходи хоть сегодня, хоть завтра - я дома.',
        instruction: 'Переведите: какой из двух - неважно',
        answer: 'İster bugün ister yarın gel, ben evdeyim.',
        variants: ['İster bugün ister yarın gel, evdeyim.'],
        breakdown: [
          { text: 'İster', label: 'ister', why: 'не ya ... ya: тут неважно, какой из двух вариантов' },
          { text: ' bugün ', label: '', why: '' },
          { text: 'ister', label: 'ister', why: '' },
          { text: ' yarın', label: '', why: '' },
        ],
        blankWhole: true,
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Решит либо сегодня, либо завтра.',
        instruction: 'Переведите: здесь сбудется один из двух - "либо... либо"',
        answer: 'Ya bugün ya yarın karar verecek.',
        variants: [],
        breakdown: [
          { text: 'Ya', label: 'ya', why: 'ya ... ya - одно из двух, и это важно; ister ... ister - неважно какое' },
          { text: ' bugün ', label: '', why: '' },
          { text: 'ya', label: 'ya', why: '' },
          { text: ' yarın', label: '', why: '' },
        ],
        blankWhole: true,
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Çay mı, kahve mi? Fark etmez.',
        sourceRu: 'хоть чай, хоть кофе - всё равно',
        instruction: 'Скажите через ister ... ister',
        answer: 'İster çay ister kahve, fark etmez.',
        variants: ['İster kahve ister çay, fark etmez.'],
        breakdown: [
          { text: 'İster', label: 'ister', why: '' },
          { text: ' çay ', label: '', why: '' },
          { text: 'ister', label: 'ister', why: 'повторять обязательно' },
          { text: ' kahve', label: '', why: '' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Haklı mısın, haksız mısın? Özür dile.',
        sourceRu: 'прав ты или нет - извинись',
        instruction: 'Скажите через ister ... ister',
        answer: 'İster haklı ol ister haksız, özür dile.',
        variants: ['İster haklı ol ister haksız ol, özür dile.'],
        breakdown: [
          { text: 'İster', label: 'ister', why: '' },
          { text: ' haklı ol ', label: '', why: 'ol - повелительное от olmak' },
          { text: 'ister', label: 'ister', why: '' },
          { text: ' haksız', label: '', why: '' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Будет он слушать или нет, я буду отстаивать своё мнение.',
        instruction: 'Переведите через ister ... ister (о нём: -sın)',
        answer: 'İster dinlesin ister dinlemesin, fikrimi savunacağım.',
        variants: [],
        breakdown: [
          { text: 'İster', label: 'ister', why: '' },
          { text: ' dinlesin ', label: '', why: 'о третьем лице - форма на -sın' },
          { text: 'ister', label: 'ister', why: '' },
          { text: ' dinlemesin', label: '', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // b1-l079 — -mesi sayesinde / yüzünden / sonucunda; dolayısıyla
  {
    rule: 'cause-mesi-sayesinde',
    explain: 'Причину-действие называют через -mesi: основа + -me/-ma + окончание того, кто действует, а за ним послелог. sayesinde - причина хорошая, "благодаря"; yüzünden - плохая, "из-за"; sonucunda - "в результате". dolayısıyla - "поэтому, следовательно" - связывает два целых предложения.',
    examples: [
      {
        parts: [
          { text: 'Otobüsün geç kal', label: '', why: '' },
          { text: 'ma', label: '-ma', why: 'действие становится существительным' },
          { text: 'sı', label: 'его', why: 'кто действует - otobüs, он в родительном' },
          { text: ' yüzünden', label: '"из-за"', why: 'причина плохая' },
          { text: ' toplantıyı kaçırdım.', label: '', why: '' },
        ],
        ru: 'Из-за того, что автобус опоздал, я пропустил совещание.',
      },
      {
        parts: [
          { text: 'Herkesin yardım et', label: '', why: '' },
          { text: 'me', label: '-me', why: '' },
          { text: 'si', label: 'его', why: '' },
          { text: ' sayesinde', label: '"благодаря"', why: 'причина хорошая' },
          { text: ' işi bitirdik.', label: '', why: '' },
        ],
        ru: 'Благодаря тому, что все помогли, мы закончили работу.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'kal',
        baseRu: 'оставаться (geç kalmak - опаздывать)',
        task: 'причина-действие (-ma) · твой',
        context: { tr: 'Senin geç ___ yüzünden treni kaçırdık.', ru: 'Из-за того, что ты опоздал, мы пропустили поезд.' },
        slots: [
          { answer: 'kal', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'me', 'dı'], label: '-ma', why: 'после "a" - -ma; у -mesi нет своего времени' },
          { answer: 'n', options: ['n', 'sı', 'm'], label: 'твой (sen)', why: 'senin ... - окончание "твой": kalman' },
        ],
        answer: 'kalman',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'çalış',
        baseRu: 'работать, заниматься',
        task: 'причина-действие (-ma) · наш',
        context: { tr: 'Çok ___ sayesinde sınavı geçtik.', ru: 'Мы сдали экзамен благодаря тому, что много занимались.' },
        slots: [
          { answer: 'çalış', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'me'], label: '-ma', why: 'после "ı" - -ma' },
          { answer: 'mız', options: ['mız', 'nız', 'ları'], label: 'наш (biz)', why: '"мы занимались" - -mız' },
        ],
        answer: 'çalışmamız',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'çök',
        baseRu: 'рушиться, падать (о системе)',
        task: 'причина-действие (-me) · его',
        context: { tr: 'Sistemin ___ yüzünden iki hafta kaybettik.', ru: 'Из-за того, что упала система, мы потеряли две недели.' },
        slots: [
          { answer: 'çök', options: [], label: '', why: '' },
          { answer: 'me', options: ['me', 'ma'], label: '-me', why: 'после "ö" - -me' },
          { answer: 'si', options: ['si', 'sı', 'm'], label: 'его', why: 'кто действует - sistem (sistemin): -si' },
        ],
        answer: 'çökmesi',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'et',
        baseRu: 'делать (yardım etmek - помогать)',
        task: 'причина-действие (-me) · ваш',
        context: { tr: 'Yardım ___ sayesinde her şey bitti.', ru: 'Благодаря вашей помощи всё готово.' },
        slots: [
          { answer: 'et', options: [], label: '', why: '' },
          { answer: 'me', options: ['me', 'ma'], label: '-me', why: 'после "e" - -me' },
          { answer: 'niz', options: ['niz', 'si', 'm'], label: 'ваш (siz)', why: '"вы помогли" - -niz' },
        ],
        answer: 'etmeniz',
        d: 1,
      },
      {
        kind: 'transform',
        source: 'Senin geç kalman sayesinde treni kaçırdık.',
        sourceRu: 'из-за того, что ты опоздал, мы пропустили поезд',
        instruction: 'Исправьте послелог: "благодаря" беде звучит как издёвка',
        answer: 'Senin geç kalman yüzünden treni kaçırdık.',
        variants: ['Geç kalman yüzünden treni kaçırdık.'],
        breakdown: [{ text: 'yüzünden', label: '"из-за"', why: 'причина плохая, кто-то виноват' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Metronun açılması yüzünden işe yarım saatte gidiyorum.',
        sourceRu: 'благодаря открытию метро я добираюсь до работы за полчаса',
        instruction: 'Исправьте послелог: причина здесь хорошая',
        answer: 'Metronun açılması sayesinde işe yarım saatte gidiyorum.',
        variants: [],
        breakdown: [{ text: 'sayesinde', label: '"благодаря"', why: 'причина хорошая' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Yağmur yağdı. Maç iptal edildi.',
        sourceRu: 'шёл дождь, поэтому матч отменили',
        instruction: 'Соедините два предложения связкой "следовательно"',
        answer: 'Yağmur yağdı, dolayısıyla maç iptal edildi.',
        variants: ['Yağmur yağdı, bu yüzden maç iptal edildi.'],
        breakdown: [{ text: 'dolayısıyla', label: '"следовательно"', why: 'отдельное слово в начале второй половины; не путать с -den dolayı' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Herkes yardım etti. Bu yüzden işi bitirdik.',
        sourceRu: 'все помогли, поэтому мы закончили работу',
        instruction: 'Скажите через -mesi sayesinde: "Благодаря тому, что все помогли..."',
        answer: 'Herkesin yardım etmesi sayesinde işi bitirdik.',
        variants: ['Herkesin yardımı sayesinde işi bitirdik.'],
        breakdown: [
          { text: 'et', label: '', why: '' },
          { text: 'me', label: '-me', why: '' },
          { text: 'si', label: 'его', why: 'действующий - в родительном: herkesin' },
          { text: ' sayesinde', label: '"благодаря"', why: 'причина хорошая' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Otobüs geç kaldı. Bu yüzden toplantıyı kaçırdım.',
        sourceRu: 'автобус опоздал, поэтому я пропустил совещание',
        instruction: 'Скажите через -mesi yüzünden: "Из-за того, что автобус опоздал..."',
        answer: 'Otobüsün geç kalması yüzünden toplantıyı kaçırdım.',
        variants: [],
        breakdown: [
          { text: 'kal', label: '', why: '' },
          { text: 'ma', label: '-ma', why: '' },
          { text: 'sı', label: 'его', why: 'действующий - в родительном: otobüsün' },
          { text: ' yüzünden', label: '"из-за"', why: 'причина плохая' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Fiyatlar arttı. İnsanlar daha az alışveriş yapıyor.',
        sourceRu: 'цены выросли - люди стали меньше покупать',
        instruction: 'Скажите через -mesi sonucunda: "В результате роста цен..."',
        answer: 'Fiyatların artması sonucunda insanlar daha az alışveriş yapıyor.',
        variants: [],
        breakdown: [
          { text: 'art', label: '', why: '' },
          { text: 'ma', label: '-ma', why: '' },
          { text: 'sı', label: 'его', why: 'действующий - в родительном: fiyatların' },
          { text: ' sonucunda', label: '"в результате"', why: 'нейтральный итог долгого процесса' },
        ],
        d: 3,
      },
    ],
  },

  // b1-l080 — -e rağmen, -mesine rağmen, -diği halde; oysa, halbuki
  {
    rule: 'concession-ragmen-halde',
    explain: '"Несмотря на..." - rağmen, и перед ним всегда дательный -e: yağmura rağmen. Если препятствие - целое действие, берём -mesine rağmen: yağmasına rağmen. Почти то же значит -diği halde - "хотя": hasta olduğu halde.',
    examples: [
      {
        parts: [
          { text: 'Yağmur', label: '', why: '' },
          { text: 'a', label: 'дательный -e', why: 'rağmen требует дательного, не винительного, как в русском "на дождь"' },
          { text: ' rağmen', label: '"несмотря на"', why: '' },
          { text: ' dışarı çıktık.', label: '', why: '' },
        ],
        ru: 'Несмотря на дождь, мы вышли на улицу.',
      },
      {
        parts: [
          { text: 'Hasta ol', label: '', why: '' },
          { text: 'duğ', label: '-dık', why: '' },
          { text: 'u', label: 'его', why: '' },
          { text: ' halde', label: '"хотя"', why: 'про факт, который уже есть' },
          { text: ' işe gitti.', label: '', why: '' },
        ],
        ru: 'Хотя он был болен, он пошёл на работу.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'yağmur',
        baseRu: 'дождь',
        task: 'дательный · rağmen',
        context: { tr: '___ rağmen dışarı çıktık.', ru: 'Несмотря на дождь, мы вышли на улицу.' },
        slots: [
          { answer: 'yağmur', options: [], label: '', why: '' },
          { answer: 'a', options: ['a', 'u', 'da'], label: 'дательный -e', why: 'rağmen - всегда с дательным: yağmura, не yağmuru' },
        ],
        answer: 'yağmura',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'her şey',
        baseRu: 'всё',
        task: 'дательный · rağmen',
        context: { tr: '___ rağmen mutluyum.', ru: 'Несмотря ни на что, я счастлив.' },
        slots: [
          { answer: 'her şey', options: [], label: '', why: '' },
          { answer: 'e', options: ['e', 'i', 'de'], label: 'дательный -e', why: 'rağmen - с дательным: her şeye' },
        ],
        answer: 'her şeye',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yağ',
        baseRu: 'идти (о дожде)',
        task: 'действие (-ma) · его · дательный',
        context: { tr: 'Yağmur ___ rağmen dışarı çıktık.', ru: 'Хотя шёл дождь, мы вышли на улицу.' },
        slots: [
          { answer: 'yağ', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'me'], label: '-ma', why: 'после "a" - -ma' },
          { answer: 'sı', options: ['sı', 'si'], label: 'его', why: '' },
          { answer: 'na', options: ['na', 'nı', 'nda'], label: 'дательный', why: 'к -mesi тоже прирастает -e: yağmasına' },
        ],
        answer: 'yağmasına',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ol',
        baseRu: 'быть',
        task: '"хотя" (-dık) · его · halde',
        context: { tr: 'Hasta ___ halde işe gitti.', ru: 'Хотя он был болен, он пошёл на работу.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'duğ', options: ['duğ', 'dığ', 'tuğ'], label: '-dık', why: 'после "o" - -duğ; после "l" - "d"' },
          { answer: 'u', options: ['u', 'um', 'un'], label: 'его', why: '"он был болен" - -u' },
        ],
        answer: 'olduğu',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ol',
        baseRu: 'быть',
        task: 'действие (-ma) · мой · дательный',
        context: { tr: 'Yorgun ___ rağmen geldim.', ru: 'Хотя я устал, я пришёл.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'duğ'], label: '-ma', why: 'с rağmen - -mesi; с halde было бы -dığı' },
          { answer: 'm', options: ['m', 'sı', 'n'], label: 'мой (ben)', why: '"я устал" - -m' },
          { answer: 'a', options: ['a', 'ı', 'da'], label: 'дательный', why: 'rağmen - с дательным: olmama' },
        ],
        answer: 'olmama',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Yağmur yağsa bile gittik.',
        sourceRu: 'хотя шёл дождь, мы пошли',
        instruction: 'Исправьте: дождь уже шёл - это факт, а не "даже если"',
        answer: 'Yağmur yağmasına rağmen gittik.',
        variants: ['Yağmur yağdığı halde gittik.'],
        breakdown: [
          { text: 'yağ', label: '', why: '' },
          { text: 'ma', label: '-ma', why: '' },
          { text: 'sı', label: 'его', why: '' },
          { text: 'na', label: 'дательный', why: '' },
          { text: ' rağmen', label: '"несмотря на"', why: '-se bile - "даже если", ещё не случилось; rağmen - про факт' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Herkes zor sandı. Sınav çok kolaydı.',
        sourceRu: 'все думали, что будет трудно, а экзамен оказался очень лёгким',
        instruction: 'Соедините связкой "а ведь, тогда как"',
        answer: 'Herkes zor sandı, oysa sınav çok kolaydı.',
        variants: ['Herkes zor sandı, halbuki sınav çok kolaydı.'],
        breakdown: [{ text: 'oysa', label: '"а ведь"', why: 'стоит в начале второго предложения: ожидание против реальности' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Hasta. Ama işe gitti.',
        sourceRu: 'он болен, но пошёл на работу',
        instruction: 'Соедините через -diği halde: "Хотя он был болен..."',
        answer: 'Hasta olduğu halde işe gitti.',
        variants: ['Hasta olmasına rağmen işe gitti.'],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'duğ', label: '-dık', why: '' },
          { text: 'u', label: 'его', why: '' },
          { text: ' halde', label: '"хотя"', why: '' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Söz verdin. Gelmedin!',
        sourceRu: 'ты обещал - и не пришёл',
        instruction: 'Скажите с упрёком через -diği halde: "Обещал же - и не пришёл!"',
        answer: 'Söz verdiğin halde gelmedin!',
        variants: [],
        breakdown: [
          { text: 'ver', label: '', why: '' },
          { text: 'diğ', label: '-dık', why: '' },
          { text: 'in', label: 'твой (sen)', why: '' },
          { text: ' halde', label: '"хотя"', why: 'у halde чаще слышен упрёк' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Ev küçük, ama bu evi seçtim.',
        sourceRu: 'дом маленький, но я выбрал его',
        instruction: 'Скажите через -mesine rağmen: "Хоть он и маленький, я выбрал этот дом"',
        answer: 'Küçük olmasına rağmen bu evi seçtim.',
        variants: ['Küçük olduğu halde bu evi seçtim.'],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'ma', label: '-ma', why: '' },
          { text: 'sı', label: 'его', why: '' },
          { text: 'na', label: 'дательный', why: '' },
          { text: ' rağmen', label: '"несмотря на"', why: '' },
        ],
        d: 3,
      },
    ],
  },

  // b1-l085 — повтор: все прошедшие времена и -sa
  {
    rule: 'b1-review-tenses-conditional',
    explain: 'Для прошлого два вопроса. Откуда я это знаю: видел сам (-di) или услышал, догадался (-mış)? И как событие лежит во времени: шло фоном (-yordu), случилось раньше другого (-mıştı), бывало регулярно (-irdi), только собиралось (-ecekti)? Для "если" вопрос один: может это ещё случиться (-ırsa) - или уже нет (-seydi ... -irdi)?',
    examples: [
      {
        parts: [
          { text: 'Vardığımda amcam çay hazırla', label: '', why: '' },
          { text: 'mış', label: '-mış', why: '' },
          { text: 'tı', label: '-dı', why: '-mıştı: уже случилось раньше другого прошлого' },
          { text: '.', label: '', why: '' },
        ],
        ru: 'Когда я приехал, дядя уже заварил чай.',
      },
      {
        parts: [
          { text: 'Bil', label: '', why: '' },
          { text: 'se', label: '-se', why: '' },
          { text: 'ydim', label: '-ydi + я', why: '-seydi: уже не изменить' },
          { text: ' gel', label: '', why: '' },
          { text: 'ir', label: 'широкое -ir', why: '' },
          { text: 'dim', label: '-di + я', why: 'вторая часть - -irdi: "сделал бы"' },
          { text: '.', label: '', why: '' },
        ],
        ru: 'Если бы я знал, я бы пришёл.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'git',
        baseRu: 'ехать, уходить',
        task: 'он · "говорят"',
        context: { tr: 'Kerem köye ___.', ru: 'Керем, говорят, уехал в деревню.' },
        slots: [
          { answer: 'git', options: [], label: '', why: '' },
          { answer: 'miş', options: ['miş', 'ti', 'se'], label: '-mış', why: '"говорят" - я услышал, сам не видел: -mış' },
        ],
        answer: 'gitmiş',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'git',
        baseRu: 'ехать',
        task: 'мы · раньше бывало',
        context: { tr: 'Çocukken her yaz köye ___.', ru: 'В детстве мы каждое лето ездили в деревню.' },
        slots: [
          { answer: 'gid', options: [], label: '', why: 'перед гласной t становится d' },
          { answer: 'er', options: ['er', 'iyor', 'ecek'], label: 'широкое -ir', why: 'бывало регулярно, а теперь нет - -irdi' },
          { answer: 'dik', options: ['dik', 'ik', 'sek'], label: '-di + мы', why: '' },
        ],
        answer: 'giderdik',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ara',
        baseRu: 'звонить',
        task: 'я · собирался',
        context: { tr: 'Seni ___ ama unuttum.', ru: 'Я собирался тебе позвонить, но забыл.' },
        slots: [
          { answer: 'ara', options: [], label: '', why: '' },
          { answer: 'yacak', options: ['yacak', 'r', 'yor'], label: 'будущее -ecek', why: '' },
          { answer: 'tım', options: ['tım', 'ım', 'sam'], label: '-dı + я', why: 'намерение в прошлом - -ecekti' },
        ],
        answer: 'arayacaktım',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yet',
        baseRu: 'хватать',
        task: 'если (может случиться)',
        context: { tr: 'Param ___, evi alırım.', ru: 'Если хватит денег, куплю дом.' },
        slots: [
          { answer: 'yet', options: [], label: '', why: '' },
          { answer: 'erse', options: ['erse', 'seydi', 'ti'], label: 'если', why: 'это ещё может случиться - -ırsa на широком времени' },
        ],
        answer: 'yeterse',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'uyu',
        baseRu: 'спать',
        task: 'они · фон (-yordu)',
        context: { tr: 'Geldiğimde herkes ___.', ru: 'Когда я пришёл, все спали.' },
        slots: [
          { answer: 'uyu', options: [], label: '', why: '' },
          { answer: 'yordu', options: ['yordu', 'du', 'yor'], label: '-yordu', why: 'сон - фон, он уже шёл, когда я пришёл; uyudu - "уснули" уже после моего прихода' },
        ],
        answer: 'uyuyordu',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'yap',
        baseRu: 'делать (yemek yapmak - готовить)',
        task: 'она · раньше другого (-mıştı)',
        context: { tr: 'Eve geldiğimde annem yemek ___.', ru: 'Когда я пришёл домой, мама уже приготовила еду.' },
        slots: [
          { answer: 'yap', options: [], label: '', why: '' },
          { answer: 'mıştı', options: ['mıştı', 'tı', 'ıyordu'], label: '-mıştı', why: 'уже случилось раньше другого прошлого; с -dı выходит, что мама начала готовить после вашего прихода' },
        ],
        answer: 'yapmıştı',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'gel',
        baseRu: 'приходить',
        task: 'ты · если бы',
        context: { tr: 'Dün ___, seni görürdüm.', ru: 'Если бы ты вчера пришёл, я бы тебя увидел.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'seydin', options: ['seydin', 'irsen', 'seydim'], label: 'если бы', why: 'вчера уже прошло - только -seydi; прийти должен был ты - -seydin' },
        ],
        answer: 'gelseydin',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'bil',
        baseRu: 'знать',
        task: 'я · "вот бы" (keşke)',
        context: { tr: 'Keşke ___!', ru: 'Вот бы я знал! (жаль, что не знал)' },
        slots: [
          { answer: 'bil', options: [], label: '', why: '' },
          { answer: 'seydim', options: ['seydim', 'meseydim', 'irsem'], label: 'keşke + -seydi', why: 'по-турецки желают того, что хотелось бы: "вот бы я знал" - без отрицания' },
        ],
        answer: 'bilseydim',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Seni arayacağım ama unuttum.',
        sourceRu: 'я собирался тебе позвонить, но забыл',
        instruction: 'Исправьте: намерение в прошлом',
        answer: 'Seni arayacaktım ama unuttum.',
        variants: ['Seni arayacaktım, ama unuttum.'],
        breakdown: [
          { text: 'ara', label: '', why: '' },
          { text: 'yacak', label: 'будущее -ecek', why: '' },
          { text: 'tım', label: '-dı + я', why: 'собирался, но не вышло - -ecekti' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Ben dün sinemaya gitmişim.',
        sourceRu: 'я вчера ходил в кино (и помню это)',
        instruction: 'Исправьте: о своём, что вы помните сами',
        answer: 'Ben dün sinemaya gittim.',
        variants: ['Dün sinemaya gittim.'],
        breakdown: [
          { text: 'git', label: '', why: '' },
          { text: 'tim', label: '-di + я', why: '-mış о себе - только "оказывается"; что помните - -di' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Bilmiyordum, o yüzden gelmedim.',
        sourceRu: 'я не знал, поэтому не пришёл',
        instruction: 'Скажите через "если бы": "Если бы я знал, я бы пришёл"',
        answer: 'Bilseydim gelirdim.',
        variants: ['Bilseydim, gelirdim.'],
        breakdown: [
          { text: 'Bil', label: '', why: '' },
          { text: 'se', label: '-se', why: '' },
          { text: 'ydim', label: '-ydi + я', why: 'уже в прошлом, не изменить' },
          { text: ' gel', label: '', why: '' },
          { text: 'ir', label: 'широкое -ir', why: '' },
          { text: 'dim', label: '-di + я', why: 'вторая часть - -irdi' },
        ],
        d: 3,
      },
    ],
  },

  // b1-l086 — финальный повтор: деепричастия и причастия
  {
    rule: 'b1-review-vocabulary',
    explain: 'Почти всё русское "когда", "пока", "после", "хотя", "чтобы" по-турецки передаётся окончанием на глаголе, и оно уезжает в конец своей части: Eve geldiğimde herkes uyuyordu. Причастия работают так же: определение стоит перед словом, без "который" - okuduğum kitap.',
    examples: [
      {
        parts: [
          { text: 'Eve gel', label: '', why: '' },
          { text: 'diğ', label: '-dık', why: '' },
          { text: 'im', label: 'мой', why: '' },
          { text: 'de', label: '"когда"', why: '"когда" - окончание в конце своей части' },
          { text: ' herkes uyuyordu.', label: '', why: '' },
        ],
        ru: 'Когда я пришёл домой, все спали.',
      },
      {
        parts: [
          { text: 'Git', label: '', why: '' },
          { text: 'tiğ', label: '-dık', why: 'после глухой "t" - "t"' },
          { text: 'im', label: 'мой', why: '"который" не нужен: определение стоит перед словом' },
          { text: ' mağazada kampanya vardı.', label: '', why: '' },
        ],
        ru: 'В магазине, куда я ходил, была акция.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'gel',
        baseRu: 'приходить',
        task: '"когда"',
        context: { tr: 'Eve ___ seni ararım.', ru: 'Когда приду домой, позвоню тебе.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'ince', options: ['ince', 'irken', 'meden'], label: '"когда"', why: '-ince - "как только, когда"; gelirken - "по дороге", gelmeden - "до того как приду"' },
        ],
        answer: 'gelince',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yap',
        baseRu: 'делать (yemek yapmak - готовить)',
        task: '"пока"',
        context: { tr: 'Yemek ___ müzik dinlerim.', ru: 'Пока готовлю, слушаю музыку.' },
        slots: [
          { answer: 'yap', options: [], label: '', why: '' },
          { answer: 'arken', options: ['arken', 'ınca', 'ıp'], label: '"пока"', why: '-ken - "пока, в то время как": yaparken' },
        ],
        answer: 'yaparken',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yap',
        baseRu: 'делать (kahvaltı yapmak - завтракать)',
        task: '"не делая, без"',
        context: { tr: 'Kahvaltı ___ çıktı.', ru: 'Он ушёл, не позавтракав.' },
        slots: [
          { answer: 'yap', options: [], label: '', why: '' },
          { answer: 'madan', options: ['madan', 'arak', 'ınca'], label: '"не делая"', why: '-meden / -madan - "не делая, без"' },
        ],
        answer: 'yapmadan',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'oku',
        baseRu: 'читать',
        task: '"который" · я',
        context: { tr: '___ kitap çok güzel.', ru: 'Книга, которую я читаю, очень хорошая.' },
        slots: [
          { answer: 'oku', options: [], label: '', why: '' },
          { answer: 'duğ', options: ['duğ', 'yan', 'yacağ'], label: '-dık', why: 'книгу читаю я - -dık с лицом' },
          { answer: 'um', options: ['um', 'u', 'un'], label: 'мой (ben)', why: '"я читаю" - -um' },
        ],
        answer: 'okuduğum',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'oku',
        baseRu: 'читать',
        task: '"который" · сам делает',
        context: { tr: 'Kitabı ___ kız benim arkadaşım.', ru: 'Девушка, которая читает книгу, - моя подруга.' },
        slots: [
          { answer: 'oku', options: [], label: '', why: '' },
          { answer: 'yan', options: ['yan', 'duğu', 'yor'], label: '-en', why: 'читает сама девушка - -en; -dığı - когда делает кто-то другой (kızın okuduğu kitap); "okuyor kız" так не говорят - "который" не бывает на -yor' },
        ],
        answer: 'okuyan',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'al',
        baseRu: 'получать, брать',
        task: '"как только"',
        context: { tr: 'Maaşımı ___ almaz borcumu ödedim.', ru: 'Как только получил зарплату, отдал долг.' },
        slots: [
          { answer: 'al', options: [], label: '', why: '' },
          { answer: 'ır', options: ['ır', 'ınca', 'dı'], label: 'широкое -ir', why: '"как только" - -ır -maz: alır almaz' },
        ],
        answer: 'alır',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Когда я пришёл домой, все спали.',
        instruction: 'Переведите: "когда" здесь передаётся окончанием',
        answer: 'Eve geldiğimde herkes uyuyordu.',
        variants: ['Eve gelince herkes uyuyordu.'],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'diğ', label: '-dık', why: '' },
          { text: 'im', label: 'мой', why: '' },
          { text: 'de', label: '"когда"', why: 'в середине фразы не ne zaman, а -diğinde' },
        ],
        blankWhole: true,
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Yorgundu ama geldi.',
        sourceRu: 'он устал, но пришёл',
        instruction: 'Скажите через "хотя": -mesine rağmen',
        answer: 'Yorgun olmasına rağmen geldi.',
        variants: ['Yorgun olduğu halde geldi.'],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'ma', label: '-ma', why: '' },
          { text: 'sı', label: 'его', why: '' },
          { text: 'na', label: 'дательный', why: '' },
          { text: ' rağmen', label: '"хотя"', why: '' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Hastaydı. Bu yüzden gelmedi.',
        sourceRu: 'он болел, поэтому не пришёл',
        instruction: 'Скажите одной фразой: "потому что" - -dığı için',
        answer: 'Hasta olduğu için gelmedi.',
        variants: ['O hasta olduğu için gelmedi.'],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'duğ', label: '-dık', why: '' },
          { text: 'u', label: 'его', why: '' },
          { text: ' için', label: '"потому что"', why: '' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Yemek yedik. Sonra yürüyüş yaptık.',
        sourceRu: 'мы поели, потом пошли гулять',
        instruction: 'Соедините через "после того как": -dikten sonra',
        answer: 'Yemek yedikten sonra yürüyüş yaptık.',
        variants: [],
        breakdown: [
          { text: 'ye', label: '', why: '' },
          { text: 'dikten', label: '-dikten', why: '' },
          { text: ' sonra', label: '"после того как"', why: '' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Işığı kapat, sonra çık.',
        sourceRu: 'выключи свет, потом выходи',
        instruction: 'Скажите через "перед тем как": -meden önce',
        answer: 'Çıkmadan önce ışığı kapat.',
        variants: [],
        breakdown: [
          { text: 'Çık', label: '', why: '' },
          { text: 'madan', label: '-madan', why: 'после "ı" - -madan' },
          { text: ' önce', label: '"перед тем как"', why: '' },
        ],
        d: 3,
      },
    ],
  },
]
